import i18next from "i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowIcon from "../../assets/images/icons/arrow-down.svg";
import { useTranslation } from "react-i18next";

interface TitleWithArrowProps {
  title: string;
}

const TitleWithArrow: React.FC<TitleWithArrowProps> = ({ title }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-4 mb-2">
      <div
        onClick={() => navigate(-1)}
        className="h-6 w-6 rounded-full bg-primary cursor-pointer"
      >
        <img
          src={ArrowIcon}
          alt=""
          className={`*:first-letter brightness-0 invert ${
            i18next?.language === "ar" ? "-rotate-90" : "rotate-90"
          } `}
        />
      </div>
      <h1 className="font-bold">{t(title)}</h1>
    </div>
  );
};

export default TitleWithArrow;
